import { Divider, Form } from 'antd';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPortSearchProgress, getPostalSearchReset } from '../../../../redux/common/CommonActions';
import Button from '../../../components/Buttons/Button';
import EmptyRecords from '../../../components/Common/EmptyRecords';
import CommonModal from '../../../components/Modals/CommonModal';
import ScrollPagination from '../../../components/Paginations/ScrollPagination';
import PortSearchCard from './PortSearchCard';
import PortSearchForm from './PortSearchForm';

const PortSearchModal = ({
  open,
  handleSelect = () => {},
  handleClose,
  portRecKey,
  portType,
  countryCode,
  cityCode,
  stateCode,
  zipCode,
  portCode,
  portName,
  labelForTestId,
}) => {
  const dispatch = useDispatch();
  const [isFiltered, setIsFiltered] = useState(false);
  const [form] = Form.useForm();
  const { portSearch } = useSelector((state) => state.common);

  const onSubmit = () => {
    setIsFiltered(true);
  };

  const handleReset = () => {
    dispatch(getPostalSearchReset());
    form.resetFields();
    setIsFiltered(false);
  };

  const handleCloseLocal = () => {
    handleClose();
    !portRecKey && handleReset();
  };

  useEffect(() => {
    if (form && open) {
      const currentValues = form.getFieldsValue();

      form.setFieldsValue({
        portType,
        countryCode: currentValues.countryCode || countryCode || undefined,
        stateCode: currentValues.stateCode || stateCode || undefined,
        city: currentValues.city || cityCode || undefined,
        postalCode: currentValues.postalCode || zipCode || undefined,
        portCode: currentValues.portCode || portCode || undefined,
        portName: currentValues.portName || portName || undefined,
      });
    }
  }, [form, portType, countryCode, stateCode, cityCode, zipCode, portCode, portName, open]);

  const handleNextPage = () => {
    const payload = {
      ...portSearch.requestData,
      PageNumber: portSearch.requestData.PageNumber + 1,
    };
    dispatch(getPortSearchProgress(payload));
  };

  return (
    <CommonModal
      title={t('translation:default.fields.portSearch')}
      open={open}
      className={`w-60 ${isFiltered ? 'vh-85' : 'h-auto'}`}
      customFooter={
        isFiltered ? (
          <div className="pr-15 pb-15">
            <Button
              id="cancelButtonId"
              variant="danger"
              type="default"
              onClick={handleCloseLocal}
              className="float-right"
            >
              {t('translation:default.buttons.cancel')}
            </Button>
          </div>
        ) : (
          <></>
        )
      }
      descriptionClassName="mb-5 d-flex flex-direction-column"
      contentClassName="p-0"
      onCancel={handleCloseLocal}
      onClose={handleCloseLocal}
      labelForTestId={labelForTestId}
    >
      <div className="py-10 d-flex flex-direction-column flex-1 overflow-hidden">
        <div className="px-15">
          <PortSearchForm formInstance={form} onSubmit={onSubmit} labelForTestId={labelForTestId} />
        </div>

        {isFiltered && <Divider className="my-15 border-top-border" />}
        <div className="flex-1 overflow-hidden ">
          {isFiltered && (
            <div className="py-15 h-100  overflow-hidden ">
              <div className=" h-100 overflow-hidden">
                <ScrollPagination
                  className="h-100 px-15"
                  loadMore={handleNextPage}
                  isLoading={portSearch?.progressing}
                  hasMore={
                    portSearch?.progressing
                      ? false
                      : portSearch?.requestData.PageNumber <
                        Math.ceil(portSearch?.totalRecords / portSearch?.requestData.PageSize)
                  }
                  scrollOffset={10}
                >
                  {portSearch?.data?.length > 0 ? (
                    <>
                      {portSearch?.data.map((row) => (
                        <PortSearchCard
                          key={row.portRecKey}
                          data={row}
                          handleSelect={handleSelect}
                          isSelected={row.portRecKey === portRecKey}
                        />
                      ))}
                    </>
                  ) : (
                    !portSearch?.progressing && (portSearch?.success || portSearch?.error) && <EmptyRecords />
                  )}
                </ScrollPagination>
              </div>
            </div>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

export default PortSearchModal;
